import React from "react";
import { Row, Col, Typography, Divider, Radio, Button, Grid } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

function Checkout() {
  const navigate = useNavigate();
  const location = useLocation();
  const cartLeads = location.state?.cartLeads || [];

  const screens = useBreakpoint();
  const isMobile = !screens.md; // ONLY true on real mobile

  const { state } = useLocation();

  const order = state?.order;
  const razorpayOrder = state?.razorpayOrder;
  const paymentLink = state?.paymentLink;

  if (!order || !razorpayOrder) {
    return <div>Invalid checkout session</div>;
  }
  const handleProceedPayment = () => {
    if (!paymentLink) return;
    window.location.href = paymentLink;
  };

  // const taxAmount =
  //   (orderSummary.overallPrice + orderSummary.platformFee) *
  //   (orderSummary.taxPercent / 100);

  const date = new Date(order.createdAt).toLocaleDateString("en-GB");
  const totalPrice = order.totalAmount;
  const overallPrice = order.totalAmount;
  const noOfLeads = order.leads.length;
  // const paymentLink = order.paymentLink;

  const boxStyle = {
    border: "1px solid #d3e6ff",
    borderRadius: 8,
    padding: isMobile ? "10px 12px" : "12px 16px",
    marginBottom: 16,
  };

  const greenBoxStyle = {
    border: "1px solid green",
    borderRadius: 8,
    padding: isMobile ? "10px 12px" : "12px 16px",
    color: "green",
    fontWeight: 600,
    backgroundColor: "#e6ffe6",
    marginBottom: 16,
  };

  return (
    <div style={{ padding: isMobile ? 12 : 20 }}>
      <Title level={3}>Checkout</Title>

      <Row gutter={[16, 16]}>
        {/* LEFT COLUMN */}
        <Col span={isMobile ? 24 : 12}>
          <div style={boxStyle}>
            <div
              style={{
                paddingBottom: 8,
                borderBottom: "1px solid #d3e6ff",
                fontWeight: 600,
                fontSize: 16,
                marginBottom: 12,
              }}
            >
              Details
            </div>

            <Row justify="space-between" style={{ marginBottom: 8 }}>
              <Text type="secondary">No of Leads</Text>
              <Text strong>{noOfLeads}</Text>
            </Row>

            <Row justify="space-between" style={{ marginBottom: 8 }}>
              <Text type="secondary">Total Price</Text>
              <Text strong>{totalPrice.toFixed(2)} AED</Text>
            </Row>

            <Divider />

            <Text strong style={{ display: "block", marginBottom: 8 }}>
              Payment Method
            </Text>

            <Radio.Group defaultValue="razorpay">
              <Radio value="razorpay">Razorpay</Radio>
            </Radio.Group>
          </div>

          <div style={greenBoxStyle}>
            <div>Important Notice</div>
            <div>Lead prices may change during checkout</div>
          </div>
        </Col>

        {/* RIGHT COLUMN */}
        <Col span={isMobile ? 24 : 12}>
          <div style={boxStyle}>
            <div
              style={{
                paddingBottom: 8,
                borderBottom: "1px solid #d3e6ff",
                fontWeight: 600,
                fontSize: 16,
                marginBottom: 12,
              }}
            >
              Order Summary
            </div>

            <Row justify="space-between" style={{ marginBottom: 8 }}>
              <Text type="secondary">No of Leads</Text>
              <Text strong>{noOfLeads}</Text>
            </Row>

            <Row justify="space-between" style={{ marginBottom: 8 }}>
              <Text type="secondary">Date</Text>
              <Text strong>{date}</Text>
            </Row>

            <Divider />

            <Text strong style={{ display: "block", marginBottom: 8 }}>
              Your Price Summary
            </Text>

            <Row justify="space-between" style={{ marginBottom: 8 }}>
              <Text type="secondary">Overall Price</Text>
              <Text strong>{overallPrice} AED</Text>
            </Row>

            {/* <Row justify="space-between" style={{ marginBottom: 8 }}>
              <Text type="secondary">Platform Fee</Text>
              <Text strong>${orderSummary.platformFee}</Text>
            </Row> */}

            {/* <Row justify="space-between" style={{ marginBottom: 8 }}>
              <Text type="secondary">Tax ({orderSummary.taxPercent}%)</Text>
              <Text strong>${taxAmount.toFixed(2)}</Text>
            </Row> */}

            <Divider />

            <Row justify="space-between" style={{ marginBottom: 8 }}>
              <Text strong>Total Price</Text>
              <Text strong>{totalPrice.toFixed(2)} AED</Text>
            </Row>

            <Button
              type="primary"
              block
              style={{ marginTop: 16 }}
              onClick={handleProceedPayment}
            >
              Proceed Payment
            </Button>

            {/* <Button
              type="primary"
              block
              style={{ marginTop: 16 }}
              onClick={() => navigate("/payment-success")}
            >
              Success
            </Button> */}

            {/* <Button
              type="default"
              danger
              block
              style={{ marginTop: 16 }}
              onClick={() => navigate("/payment-failure")}
            >
              Failed
            </Button> */}
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Checkout;
